<script>
import Button from '../../Button.vue'
import ImageCropper from '../../../user/ImageCropper.vue'
export default {
  name: 'choose-image',
  components: {
    Button,
    ImageCropper,
  },
  props: {
    cropperLoading: {
      default: false,
      type: Boolean,
    },
    imageCropperModal: {
      default: false,
      type: Boolean,
    },
    defaultImage: {
      type: String,
      default: '',
    },
    isUser: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      image: null,
    }
  },
  methods: {
    log(file) {
      this.image = file
      this.$emit('productImage', file)
    },
  },
  beforeMount() {
    if (this.defaultImage) {
      this.image = this.defaultImage
    }
  },
}
</script>

<template>
  <div :class="isUser ? `user-style` : `mainInput`">
    <div v-if="isUser" class="me-4">
      <img style="border-radius:50%" v-if="image" width="80" height="80" :src="image" />
      <img v-else src="@/assets/images/users/account-circle.svg" width="80" height="80" />
    </div>
    <div v-else class="me-4">
      <img v-if="image" width="100" height="70" :src="image" />
      <img v-else src="@/assets/images/default-pic.svg" width="100" height="70" />
    </div>
    <div class="labelStyle" @click.prevent="imageCropperModal = true">
      <Button text="انتخاب عکس" btnClass="aprove" />
    </div>
    <b-modal v-model="imageCropperModal" hide-footer hide-header centered>
      <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="log($event)" />
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.mainInput {
  display: flex;
  align-items: flex-end;
  margin-bottom: 30px;
}
.user-style {
  display: flex;
  align-items: flex-end;
}
.labelStyle {
  min-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

.aprove {
  background: #556ee6;
  border-radius: 2.6px;
  padding: 7px 20px !important;
  span {
    font-size: 11px;
  }
}
</style>
